(function () {
  function init(root) {


      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      var form = root.querySelector('[data-unico-form]');
      var price = root.querySelector('[data-unico-price]');
      var addButton = root.querySelector('[data-add-button]');
      var addLabel = root.querySelector('[data-add-label]');
      var error = root.querySelector('[data-error]');
      var errorText = root.querySelector('[data-error-text]');
      var freeComposer = root.querySelector('[data-free-composer]');
      var selectionPanel = root.querySelector('[data-selection-panel]');
      var selectionImage = root.querySelector('[data-selection-image]');
      var threadConfirmation = root.querySelector('[data-thread-confirmation]');
      var threadConfirmationInput = root.querySelector('[data-thread-confirmation-input]');
      var threadExplanation = root.querySelector('[data-thread-explanation]');
      var threadSummary = root.querySelector('[data-thread-summary]');
      var threadCompact = root.querySelector('[data-thread-compact]');
      var threadStatus = root.querySelector('[data-thread-status]');
      var giftSection = root.querySelector('[data-gift-section]');
      var giftDuo = root.querySelector('[data-gift-duo]');
      var giftSolo = root.querySelector('[data-gift-solo]');
      var giftSoloInput = root.querySelector('[data-gift-solo-input]');
      var galleryMain = root.querySelector('.unico-gallery__main');
      var galleryPrevious = root.querySelector('[data-gallery-previous]');
      var galleryNext = root.querySelector('[data-gallery-next]');
      var galleryCounter = root.querySelector('[data-gallery-counter]');
      var packagingReassurance = root.querySelector('[data-packaging-reassurance]');
      var optionNames = JSON.parse(root.querySelector('[data-unico-options]').textContent || '[]');
      var variants = JSON.parse(root.querySelector('[data-unico-variants]').textContent || '[]');
      var colorRules = JSON.parse(root.querySelector('[data-unico-color-rules]').textContent || '[]');
      var mediaScript = root.querySelector('[data-unico-media]');
      var variantImages = mediaScript ? JSON.parse(mediaScript.textContent || '{}') : {};
      variants.forEach(function (variant) {
        if (!variant.image_url && variant.media_id) variant.image_url = variantImages[variant.media_id] || null;
      });

      var motif1 = root.dataset.motifOne || '';
      var motif2 = root.dataset.motifTwo || '';
      var mediaPanels = Array.prototype.slice.call(root.querySelectorAll('[data-media-panel]'));
      var currentMediaIndex = 0;
      var duoPreview = root.querySelector('[data-duo-preview]');
      var duoControls = root.querySelector('[data-duo-controls]');
      var isAstroPreview = Boolean(duoPreview && duoPreview.hasAttribute('data-astro-preview'));
      var isCaractere = Boolean(root.dataset.caractereHandle);
      var caractereThreads = {
        black: {option:'black',name:'Noir',hex:'#111111'},
        ivory: {option:'ivory',name:'Ivoire',hex:'#F5F0E6'},
        navy: {option:'navy',name:'Bleu marine',hex:'#14243A'},
        sky: {option:'sky',name:'Bleu ciel',hex:'#B1CBEA'},
        burgundy: {option:'burgundy',name:'Bordeaux',hex:'#702C40'},
        rose: {option:'rose',name:'Rose poudré',hex:'#EAC6CD'},
        terracotta: {option:'terracotta',name:'Terracotta',hex:'#B15F45'},
        sage: {option:'sage',name:'Vert sauge',hex:'#A4B29A'},
        khaki: {option:'khaki',name:'Kaki',hex:'#515247'},
        chocolate: {option:'chocolate',name:'Chocolat',hex:'#65544E'},
        gold: {option:'gold',name:'Doré',hex:'#B59145'}
      };
      var caractereFamilies = {
        'bienveillance-main-de-fatma':['gold'],
        'generosite-coeur':['rose','burgundy'],
        'perseverance-carpe':['navy','sky'],
        'curiosite-boussole':['sky','navy'],
        'loyaute-ancre':['sky','navy'],
        'optimisme-soleil':['terracotta'],
        'force-phenix':['terracotta'],
        'courage-salamandre':['khaki'],
        'patience-tortue':['sky','navy'],
        'sensibilite-rose':['rose','burgundy']
      };
      function allowedThreadOptions(color) {
        if (isCaractere) return caractereOptions(color);
        var fabric = normalize(color);
        if (fabric === 'blanc' || fabric === 'naturel') return ['black'];
        if (fabric === 'noir') return ['ivory'];
        return ['black', 'ivory'];
      }
      function syncVariantUrl() {
        if (state.mode !== 'solo') return;
        var variant = selectedVariant(1);
        var url = new URL(window.location.href);
        if (variant) url.searchParams.set('variant', String(variant.id));
        else url.searchParams.delete('variant');
        if (url.href !== window.location.href) window.history.replaceState({}, '', url);
      }
      function caractereOptions(color) {
        var family=caractereFamilies[root.dataset.caractereHandle] || ['navy','sky'];
        var fabric=normalize(color);
        if(fabric==='naturel' || fabric==='blanc')return Array.from(new Set(family.concat(['black'])));
        if(fabric==='noir')return Array.from(new Set(['ivory'].concat(family)));
        var combinations={
          'bleu marine':['ivory','sky'],
          'bordeaux':['ivory','rose'],
          'terracotta':['ivory','black'],
          'bleu glace':['navy','black'],
          'bleu ciel':['navy','black'],
          'chocolat':['ivory','black'],
          'jaune':['ivory','black'],
          'kaki':['ivory','black'],
          'rose poudre':['burgundy','ivory']
        };
        return combinations[fabric] || ['black','ivory'];
      }
      if(isCaractere)root.querySelectorAll('[data-thread-choices]').forEach(function(group){
        var slot=group.dataset.threadChoices;
        group.replaceChildren();
        Object.values(caractereThreads).forEach(function(thread){
          var button=document.createElement('button');button.type='button';
          button.dataset.threadChoice=slot;button.dataset.threadOption=thread.option;
          var swatch=document.createElement('i');swatch.setAttribute('aria-hidden','true');swatch.style.setProperty('--thread-choice',thread.hex);
          var label=document.createElement('span');label.textContent=thread.name;
          button.append(swatch,label);group.appendChild(button);
        });
      });
      var duoCloseButton = root.querySelector('[data-duo-closeup]');
      if (duoPreview) { var caption = duoPreview.querySelector('.unico-duo-preview__caption'); if (caption) caption.textContent = 'Aperçu'; }
      var duoCloseupMode = false;
      var duoLastSlot = '1';
      var allMediaPanels = mediaPanels.slice();
      if (duoPreview) {
        ['1','2'].forEach(function(slot) {
          var panel = document.createElement('div');
          panel.className = 'unico-gallery__panel unico-duo-single';
          panel.dataset.mediaPanel = 'duo-single-' + slot;
          panel.dataset.duoSingle = slot;
          panel.setAttribute('role', 'group');
          panel.setAttribute('aria-label', 'T-shirt ' + slot + ' personnalisé');
          panel.hidden = true;
          duoPreview.after(panel);
          allMediaPanels.push(panel);
        });
      }

      function refreshGalleryThreads() {
        if (!duoControls) return;
        duoControls.querySelectorAll('[data-gallery-thread-group]').forEach(function(node) { node.remove(); });
        if(state.mode !== 'solo') return;
        ['1','2'].forEach(function(slot) {
          var source = root.querySelector('[data-thread-choices="'+slot+'"]');
          if (!source || source.hidden) return;
          var row = duoControls.querySelector('[data-duo-more="'+slot+'"]').closest('fieldset');
          var group = document.createElement('div');
          group.className = 'unico-gallery-threads';
          group.dataset.galleryThreadGroup = slot;
          group.setAttribute('role','group');
          group.setAttribute('aria-label','Fil de broderie du t-shirt '+slot);
          var label = document.createElement('span');
          label.className = 'unico-gallery-threads__label';
          label.textContent = 'Fil de broderie';
          var selectedName=document.createElement('span');
          selectedName.className='unico-gallery-threads__selected';
          var current=state.threads[slot];
          selectedName.textContent=current ? current.name : '';
          label.appendChild(selectedName);
          group.appendChild(label);
          var buttons = document.createElement('div');
          source.querySelectorAll('[data-thread-choice]').forEach(function(original) {
            if(original.hidden)return;
            var button = original.cloneNode(true);
            button.removeAttribute('data-thread-choice');
            button.dataset.galleryThread = slot;
            button.setAttribute('aria-label','Fil '+globalThread(original.dataset.threadOption).name+' pour le t-shirt '+slot);
            button.setAttribute('title',globalThread(original.dataset.threadOption).name);
            button.replaceChildren(original.querySelector('i').cloneNode(true));
            buttons.appendChild(button);
          });
          group.appendChild(buttons);
          row.appendChild(group);
        });
      }

      function refreshDuoSingles() {
        if (!duoPreview) return;
        var source = duoPreview.querySelector('svg.unico-duo-preview__canvas');
        if (!source) return;
        ['1','2'].forEach(function(slot) {
          if (state.mode === 'solo' && slot === '2') return;
          var panel = root.querySelector('[data-duo-single="' + slot + '"]');
          var svg = source.cloneNode(true);
          var idMap = {};
          svg.querySelectorAll('[id]').forEach(function(node) { idMap[node.id] = node.id + '-single-' + slot; node.id = idMap[node.id]; });
          svg.querySelectorAll('*').forEach(function(node) {
            Array.from(node.attributes).forEach(function(attr) {
              var value = attr.value;
              Object.keys(idMap).forEach(function(id) { value = value.split('#' + id + ')').join('#' + idMap[id] + ')'); if (value === '#' + id) value = '#' + idMap[id]; });
              if (value !== attr.value) node.setAttribute(attr.name, value);
            });
          });
          svg.querySelectorAll('[data-calibrated-shirt]').forEach(function(shirt) {
            if (shirt.dataset.calibratedShirt !== slot) shirt.remove();
            else shirt.setAttribute('transform', 'translate(190 55)');
          });
          svg.setAttribute('viewBox', '0 0 850 950');
          svg.setAttribute('class', 'unico-duo-single__canvas');
          svg.setAttribute('aria-label', 'T-shirt ' + slot + ' avec ses broderies');
          panel.setAttribute('style', duoPreview.getAttribute('style') || '');
          var oldColors=panel.querySelector('.unico-duo-controls__colors');
          var previousScroll=oldColors ? oldColors.scrollLeft : 0;
          panel.replaceChildren(svg);
          if (slot === '1' && state.mode === 'solo') {
            var controls = duoControls.cloneNode(true);
            controls.hidden = false;
            controls.dataset.singleControls = '';
            controls.querySelectorAll('fieldset').forEach(function(row,index) { if(index > 0) row.remove(); });
            var legend = controls.querySelector('legend');
            var colorName = controls.querySelector('[data-duo-color-name="1"]');
            legend.replaceChildren(document.createTextNode('Couleur du t-shirt'),colorName);
            var threadGroup=controls.querySelector('[data-gallery-thread-group]');
            if(threadGroup) controls.appendChild(threadGroup);
            controls.querySelectorAll('[id]').forEach(function(node) { node.id += '-single'; });
            controls.querySelectorAll('[aria-controls]').forEach(function(node) { node.setAttribute('aria-controls',node.getAttribute('aria-controls')+'-single'); });
            panel.appendChild(controls);
            requestAnimationFrame(function(){var strip=controls.querySelector('.unico-duo-controls__colors');if(strip)strip.scrollLeft=previousScroll;});
            if (!state.colors[1] && !isAstroPreview) {
              svg.style.visibility = 'hidden';
              var empty = document.createElement('p');
              empty.textContent = 'Choisissez une couleur pour voir votre t-shirt.';
              empty.style.cssText = 'position:absolute;top:44%;left:24px;right:24px;margin:0;text-align:center;font-size:13px;line-height:1.5;color:#5b5956';
              panel.appendChild(empty);
            }

            var caption = document.createElement('span');caption.className = 'unico-duo-preview__caption';caption.textContent = 'Aperçu';panel.appendChild(caption);
          }
        });
      }

      var duoZoom = null, duoZoomIndex = 0, duoZoomSources = [], duoZoomFocus = null;
      function cloneDuoSvg(source, suffix) {
        var svg = source.cloneNode(true), ids = {};
        svg.querySelectorAll('[id]').forEach(function(node) { ids[node.id] = node.id + suffix; node.id = ids[node.id]; });
        svg.querySelectorAll('*').forEach(function(node) {
          Array.from(node.attributes).forEach(function(attr) {
            var value = attr.value.replace(/#([a-zA-Z0-9_-]+)/g, function(match,id) { return ids[id] ? '#' + ids[id] : match; });
            if (value !== attr.value) node.setAttribute(attr.name, value);
          });
        });
        svg.removeAttribute('class');
        return svg;
      }
      function refreshDuoThumbnail() {
        if (!duoCloseButton) return;
        duoCloseButton.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M14 4h6v6M20 4l-7 7M10 20H4v-6M4 20l7-7" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      }
      function showDuoZoom(index) {
        duoZoomIndex = (index + duoZoomSources.length) % duoZoomSources.length;
        var source = duoZoomSources[duoZoomIndex];
        var svg = cloneDuoSvg(source.querySelector('svg'), '-zoom');
        var stage = duoZoom.querySelector('[data-zoom-stage]');
        stage.setAttribute('style', duoPreview.getAttribute('style') || '');
        stage.replaceChildren(svg);
        duoZoom.querySelector('[data-zoom-count]').textContent = state.mode === 'solo' ? 'Votre t-shirt' : ['Votre duo','T-shirt 1 · ' + state.colors[1], 'T-shirt 2 · ' + state.colors[2]][duoZoomIndex];
        duoZoom.querySelectorAll('[data-zoom-step]').forEach(function(button) { button.hidden = duoZoomSources.length < 2; });
      }
      function openDuoZoom() {
        if (!duoZoom) {
          duoZoom = document.createElement('dialog');
          duoZoom.className = 'unico-duo-zoom';
          duoZoom.setAttribute('aria-label','Vos t-shirts en détail');
          duoZoom.innerHTML = '<button type="button" class="unico-duo-zoom__close" aria-label="Fermer">×</button><div data-zoom-stage></div><div class="unico-duo-zoom__nav"><button type="button" data-zoom-step="-1" aria-label="Vue précédente">‹</button><span data-zoom-count aria-live="polite"></span><button type="button" data-zoom-step="1" aria-label="Vue suivante">›</button></div>';
          document.body.appendChild(duoZoom);
          duoZoom.querySelector('.unico-duo-zoom__close').addEventListener('click',function(){duoZoom.close();});
          duoZoom.addEventListener('close',function(){document.documentElement.style.overflow = duoZoom.dataset.previousOverflow || ''; if(duoZoomFocus)duoZoomFocus.focus();});
          duoZoom.querySelectorAll('[data-zoom-step]').forEach(function(button){button.addEventListener('click',function(){showDuoZoom(duoZoomIndex + Number(button.dataset.zoomStep));});});
          duoZoom.addEventListener('keydown',function(event){if(event.key === 'ArrowRight')showDuoZoom(duoZoomIndex+1);if(event.key === 'ArrowLeft')showDuoZoom(duoZoomIndex-1);});
          var start = null;
          duoZoom.querySelector('[data-zoom-stage]').addEventListener('touchstart',function(event){ start = event.touches.length === 1 ? {x:event.touches[0].clientX,y:event.touches[0].clientY} : null; },{passive:true});
          duoZoom.querySelector('[data-zoom-stage]').addEventListener('touchend',function(event){if(!start)return;var dx=event.changedTouches[0].clientX-start.x,dy=event.changedTouches[0].clientY-start.y;start=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy))showDuoZoom(duoZoomIndex+(dx<0?1:-1));},{passive:true});
        }
        duoZoomSources = state.mode === 'duo' ? [duoPreview,root.querySelector('[data-duo-single="1"]'),root.querySelector('[data-duo-single="2"]')] : [root.querySelector('[data-duo-single="1"]')];
        duoZoomFocus = document.activeElement;
        showDuoZoom(0);
        duoZoom.dataset.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        duoZoom.showModal();
      }

      var duoPhotoMap = duoPreview ? JSON.parse(duoPreview.querySelector("[data-duo-photo-map]").textContent) : {};
      duoPhotoMap = Object.fromEntries(Object.entries(duoPhotoMap).map(function(entry) { return [normalize(entry[0]), entry[1]]; }));
      var duoPhotoColors = {"Blanc": "#f3efec", "Noir": "#222526", "Naturel": "#eee8da", "Bleu glace": "#dfeaec", "Bleu ciel": "#b1cbea", "Chocolat": "#625048", "Bleu marine": "#19202d", "Jaune": "#f2d787", "Rose poudré": "#eac6cd", "Bordeaux": "#4f2431", "Terracotta": "#87372f", "Kaki": "#515247"};
      duoPhotoColors = Object.fromEntries(Object.entries(duoPhotoColors).map(function(entry) { return [normalize(entry[0]), entry[1]]; }));

      function duoFabricColor(name) {
        var rule = findColorRule(name);
        return duoPhotoMap[normalize(name)]?.color || duoPhotoColors[normalize(name)] || (rule && rule.hex) || '#f7f0e2';
      }

      var galleryColorsExpanded = {};
      function refreshDuoSwatches() {
        if(!duoControls) return;
        ['1','2'].forEach(function(slot) {
          var more=duoControls.querySelector('[data-duo-more="'+slot+'"]');
          more.hidden=false;
          var expanded=!!galleryColorsExpanded[slot];
          more.textContent=expanded?'‹':'›';
          more.setAttribute('aria-expanded',String(expanded));
          more.setAttribute('aria-label',(expanded?'Réduire les couleurs du t-shirt ':'Afficher toutes les couleurs du t-shirt ')+slot);
          more.setAttribute('title','Autres couleurs du t-shirt');
          more.closest('fieldset').classList.toggle('is-expanded',expanded);
          duoControls.querySelectorAll('[data-duo-color="'+slot+'"]').forEach(function(button) {button.hidden=false;});
        });
      }

      function renderDuoPreview(reveal) {
        if (!duoPreview) return;
        var active = state.mode === 'duo';
        duoControls.hidden = !active;
        var palette = root.querySelector('[data-palette]');
        var colors = {1: state.colors[1] || (isAstroPreview ? 'Naturel' : palette?.dataset.colorOne) || 'Terracotta', 2: state.colors[2] || palette?.dataset.colorTwo || 'Blanc'};
        ['1', '2'].forEach(function(slot) {
          var thread = state.threads[slot] || (!active ? standardThread(colors[slot]) : null);
          var threadHex = thread ? (thread.option ? thread.hex : duoFabricColor(thread.name)) : duoFabricColor(colors[slot === '1' ? '2' : '1']);
          duoPreview.style.setProperty('--duo-fabric-' + slot, duoFabricColor(colors[slot]));
          var photo = duoPhotoMap[normalize(colors[slot])];
          duoPreview.querySelector('[data-duo-navy-label="' + slot + '"]').style.display = photo && photo.code === 'C727' ? '' : 'none';
          var photoNode = duoPreview.querySelector('[data-duo-photo="' + slot + '"]');
          var photoTransform = duoPreview.querySelector('[data-duo-photo-transform="' + slot + '"]');
          var photoClip = duoPreview.querySelector('[data-duo-photo-clip="' + slot + '"]');
          if (photo) {
            photoNode.setAttribute('data-unico-href', photo.url);
            photoNode.setAttribute('width', photo.width);
            photoNode.setAttribute('height', photo.height);
            photoNode.removeAttribute('filter');
            photoTransform.setAttribute('transform', photo.transform);
            photoClip.setAttribute('clip-path', 'url(#' + photo.clip + ')');
          } else {
            photoNode.setAttribute('data-unico-href', root.dataset.unicoReferenceImage);
            photoNode.setAttribute('width', '1500'); photoNode.setAttribute('height', '1875');
            photoTransform.setAttribute('transform', 'scale(0.58) translate(-380 -286)');
            var tint = duoPreview.querySelector('[data-duo-tint="' + slot + '"]');
            photoNode.setAttribute('filter', 'url(#' + tint.id + ')');
            photoClip.setAttribute('clip-path', 'url(#' + tint.id.replace(/-tint-[12]$/, '-source-outline') + ')');
          var rgb = duoFabricColor(colors[slot]).slice(1).match(/../g).map(function(v) { return parseInt(v,16)/255; });
          ['R','G','B'].forEach(function(channel,index) {
            var slope = .30 + rgb[index] * .70;
            var func = duoPreview.querySelector('[data-duo-tint="' + slot + '"] feFunc' + channel);
            func.setAttribute('slope', slope.toFixed(4));
            func.setAttribute('intercept', (rgb[index] - slope * .33023).toFixed(4));
          });
          }
          var shirtLength = photo ? photo.length : 756.32;
          var artLink = duoPreview.querySelector('[data-duo-art="' + slot + '"]').getAttribute('href');
          var art = duoPreview.querySelector(artLink);
          var artUses = art.querySelectorAll('use');
          var isMoon = active ? slot === '2' : normalize(state.motif) === normalize(motif2);
          artUses[0].setAttribute('href', artUses[0].getAttribute('href').replace(/-motif-[12]$/, isMoon ? '-motif-2' : '-motif-1'));
          var scales = {"duo-la-bonne-carte-as-de-pique-as-de-trefle": [1, 1], "heritage-duo": [1, 0.889], "duo-t-shirts-arbre-jeune-pousse": [1, 0.889], "le-roi-la-reine": [1, 1], "carpes": [1, 1], "pieces-de-puzzle": [1, 1], "as-de-pique-as-de-trefle-copie": [1, 1], "duo-t-shirts-brodes-puzzle": [1, 1], "le-cadenas-la-cle": [1, 1], "coeurs-de-cupidon": [1, 1], "as-de-pique-as-de-trefle-copie-1": [1, 1], "duo-t-shirts-brodes-coeurs-cupidon": [1, 1], "tortue-baby-tortue": [1, 0.8181818181818182], "rose-et-bouton-de-rose": [1, 0.8181818181818182]};
          var pairScale = scales[duoPreview.dataset.duoProduct];
          var motifSize = isAstroPreview ? 43.354 * 1.21 * 1.02 : pairScale ? 43.354 * 1.15 * 1.10 * pairScale[isMoon ? 1 : 0] : 43.354 * (isMoon ? 1.10 : 1.15 * 1.10);
          artUses[0].setAttribute('width', String(motifSize));
          artUses[0].setAttribute('height', String(motifSize));
          artUses[0].setAttribute('x', String(311.307 - motifSize / 2));
          artUses[0].setAttribute('y', String(shirtLength * .31 - motifSize / 2));
          artUses[1].setAttribute('width', String(43.354 * 1.21));
          artUses[1].setAttribute('height', String(8.671 * 1.21));
          artUses[1].setAttribute('x', String(34 - 43.354 * .105));
          artUses[1].setAttribute('y', String(shirtLength - 34 - 8.671 * .105 - 8.671 * 1.10 * .5));
          var bar = art.querySelector('rect');
          var sleevePositions = {"C727": {"x": 555.25, "y": 284.13, "angle": -36.05}, "C005": {"x": 560.15, "y": 288.85, "angle": -39.29}, "C151": {"x": 553.1, "y": 309.36, "angle": -31.08}, "C150": {"x": 553.16, "y": 309.36, "angle": -31.13}, "C728": {"x": 558.92, "y": 299.86, "angle": -36.12}, "C149": {"x": 566.62, "y": 304.87, "angle": -34.67}, "C223": {"x": 559.7, "y": 288.62, "angle": -39.2}, "C356": {"x": 559.58, "y": 318.54, "angle": -32.88}, "C135": {"x": 545.93, "y": 331.62, "angle": -29.48}, "C054": {"x": 550.9, "y": 274.18, "angle": -38.27}, "C018": {"x": 560.02, "y": 288.84, "angle": -39.18}};
          var sleeve = sleevePositions[photo?.code] || {x:552,y:290,angle:-39};
          var sleeveAngle = sleeve.angle * Math.PI / 180;
          var sleeveX = sleeve.x + Math.cos(sleeveAngle) * 9 + Math.sin(sleeveAngle) * 11;
          var sleeveY = sleeve.y + Math.sin(sleeveAngle) * 9 - Math.cos(sleeveAngle) * 11 - 5;
          bar.setAttribute('x', String(sleeveX - 10.8385));
          bar.setAttribute('y', String(sleeveY - 2.168));
          bar.setAttribute('transform', 'rotate(' + sleeve.angle + ' ' + sleeveX + ' ' + sleeveY + ')');
          if (isAstroPreview && !isCaractere) {
            bar.setAttribute('display','none');
            var sleeveSymbol = art.querySelector('[data-astro-sleeve]');
            var sleeveSize = 43.354 * 1.21 * .46;
            sleeveSymbol.setAttribute('x',String(sleeveX-sleeveSize/2));
            sleeveSymbol.setAttribute('y',String(sleeveY-sleeveSize/2-8));
            sleeveSymbol.setAttribute('width',String(sleeveSize));sleeveSymbol.setAttribute('height',String(sleeveSize));
            sleeveSymbol.setAttribute('transform','rotate('+sleeve.angle+' '+sleeveX+' '+sleeveY+')');
          }
          if(isCaractere){bar.removeAttribute('display');art.querySelector('[data-astro-sleeve]').setAttribute('display','none');}
          duoPreview.style.setProperty('--duo-thread-' + slot, threadHex);
          var lightNeck = ['noir','chocolat','bleu marine','bordeaux','terracotta','kaki'].indexOf(normalize(colors[slot])) >= 0;
          duoPreview.style.setProperty('--duo-neck-' + slot, state.mode === 'solo' ? (thread && (thread.option === 'ivory' || normalize(thread.name) === 'ivoire') ? '#ffffff' : '#111111') : (lightNeck ? '#f4f0e6' : '#181818'));
          duoControls.querySelector('[data-duo-color-name="' + slot + '"]').textContent = colors[slot];
          duoControls.querySelectorAll('[data-duo-color="' + slot + '"]').forEach(function(button) {
            var selected = normalize(button.dataset.value) === normalize(state.colors[slot]);
            button.setAttribute('aria-pressed', String(selected));
            button.classList.toggle('is-active', selected);
            button.style.setProperty('--duo-swatch', duoFabricColor(button.dataset.value));
          });
        });
        refreshDuoSwatches();
        refreshGalleryThreads();
        refreshDuoSingles();
        duoPreview.setAttribute('aria-label', motif1 + ' : ' + colors[1] + '. ' + motif2 + ' : ' + colors[2] + '.');
        refreshDuoThumbnail();
        if (reveal) showMediaById(active ? 'duo-preview' : 'duo-single-1');
      }




      var state = {
        mode: 'solo',
        motif: motif1,
        motifIconUrl: '',
        colors: { 1: '', 2: '' },
        sizes: { 1: '', 2: '' },
        threadChoices: { 1: '', 2: '' },
        threads: { 1: null, 2: null },
        threadConfirmationRequired: false,
        threadKey: '',
        giftPack: false
      };

      function normalize(value) {
        return String(value || '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .trim()
          .toLowerCase()
          .replace(/^creme$/, 'naturel');
      }

      function updateSlotOneIcons() {
        var url = root.dataset.iconOneUrl || '';

        if (state.mode === 'solo') {
          url = state.motifIconUrl || '';
        }

        root.querySelectorAll('[data-slot-one-icon]').forEach(function (wrapper) {
          wrapper.innerHTML = '';
          wrapper.hidden = state.mode === 'solo' && !url;

          if (url) {
            var image = document.createElement('img');
            image.src = url;
            image.alt = '';
            image.className = 'unico-dynamic-motif-image';
            wrapper.appendChild(image);
          } else if (state.mode === 'duo') {
            wrapper.textContent = '1';
          }
        });
      }

      var normalizedOptions = optionNames.map(normalize);
      var colorIndex = normalizedOptions.findIndex(function (name) {
        return name === 'couleur' || name === 'color' || name.indexOf('couleur') !== -1;
      });
      var sizeIndex = normalizedOptions.findIndex(function (name) {
        return name === 'taille' || name === 'size' || name.indexOf('taille') !== -1;
      });
      var formulaIndex = normalizedOptions.findIndex(function (name) {
        return name === 'formule' || name === 'formula';
      });
      var invalidOptions = colorIndex < 0 || sizeIndex < 0 || formulaIndex >= 0 || optionNames.length !== 2;

      function globalThread(option) {
        if(isCaractere && caractereThreads[option])return caractereThreads[option];
        if (option === 'black') {
          return {
            option: 'black',
            name: root.dataset.threadBlackName || 'Noir',
            hex: root.dataset.threadBlackHex || '#111111'
          };
        }

        return {
          option: 'ivory',
          name: root.dataset.threadIvoryName || 'Ivoire',
          hex: root.dataset.threadIvoryHex || '#F5F0E6'
        };
      }

      function findColorRule(color) {
        return colorRules.find(function (rule) {
          return normalize(rule.name) === normalize(color);
        }) || null;
      }

      function threadOptionFromName(name) {
        var normalized = normalize(name);
        var blackName = normalize(root.dataset.threadBlackName || 'Noir');

        if (
          normalized === blackName ||
          normalized.indexOf('noir') !== -1 ||
          normalized.indexOf('black') !== -1
        ) {
          return 'black';
        }

        return 'ivory';
      }

      function standardThread(color) {
        if(isCaractere)return globalThread(caractereOptions(color)[0]);
        var allowed = allowedThreadOptions(color);
        if (allowed.length === 1) return globalThread(allowed[0]);
        var rule = findColorRule(color);

        if (rule && rule.standard_name && rule.standard_name !== 'auto') {
          var customOption = threadOptionFromName(rule.standard_name);
          var fallback = globalThread(customOption);

          return {
            option: customOption,
            name: rule.standard_name,
            hex: rule.standard_hex || fallback.hex
          };
        }

        var blackColors = [
          'naturel',
          'blanc',
          'aloe vera',
          'bleu glace',
          'jaune',
          'rose poudre',
          'lavande'
        ];

        return globalThread(
          blackColors.indexOf(normalize(color)) !== -1
            ? 'black'
            : 'ivory'
        );
      }

      function matchedThread(color) {
        var rule = findColorRule(color);

        if (rule && rule.matched_name) {
          return {
            option: '',
            name: rule.matched_name,
            hex: rule.matched_hex || rule.hex || '#FFFFFF'
          };
        }

        return {
          option: '',
          name: color,
          hex: rule && rule.hex ? rule.hex : '#FFFFFF'
        };
      }

      function isToneOnTonePair(color1, color2) {
        if (!color1 || !color2) return false;
        if (normalize(color1) === normalize(color2)) return true;

        return Array.prototype.slice.call(
          root.querySelectorAll('[data-palette][data-tone-on-tone="true"]')
        ).some(function (palette) {
          var first = normalize(palette.dataset.colorOne);
          var second = normalize(palette.dataset.colorTwo);
          var selectedFirst = normalize(color1);
          var selectedSecond = normalize(color2);

          return (
            first === selectedFirst && second === selectedSecond
          ) || (
            first === selectedSecond && second === selectedFirst
          );
        });
      }

      function buildThreadPlan() {
        if(state.mode !== 'solo') state.threadChoices = {1:'',2:''};
        var color1 = state.colors[1];
        var color2 = state.colors[2];
        var plan = {
          type: 'standard',
          ready: false,
          confirmationRequired: false,
          threads: { 1: null, 2: null }
        };

        if (state.mode === 'solo') {
          if (!color1) return plan;

          if(!allowedThreadOptions(color1).includes(state.threadChoices[1]))state.threadChoices[1]='';
          var soloRecommended = standardThread(color1);
          plan.ready = true;
          plan.confirmationRequired = true;
          plan.threads[1] = state.threadChoices[1]
            ? globalThread(state.threadChoices[1])
            : soloRecommended;
          return plan;
        }

        if (!color1 || !color2) return plan;

        var toneOnTone = isToneOnTonePair(color1, color2);

        if (!toneOnTone && normalize(color1) !== normalize(color2)) {
          plan.type = 'inverted';
          plan.ready = true;
          plan.confirmationRequired = false;
          plan.threads[1] = matchedThread(color2);
          plan.threads[2] = matchedThread(color1);
          return plan;
        }

        var recommended1 = standardThread(color1);
        var recommended2 = standardThread(color2);

        plan.ready = true;
        plan.confirmationRequired = true;
        plan.threads[1] = state.threadChoices[1]
          ? globalThread(state.threadChoices[1])
          : recommended1;
        plan.threads[2] = state.threadChoices[2]
          ? globalThread(state.threadChoices[2])
          : recommended2;

        return plan;
      }

      function renderThreadRow(slot, thread, showChoices) {
        showChoices = showChoices && state.mode === 'solo';
        var row = root.querySelector('[data-thread-row="' + slot + '"]');
        var shirtColor = root.querySelector('[data-thread-shirt-color="' + slot + '"]');
        var swatch = root.querySelector('[data-thread-swatch="' + slot + '"]');
        var name = root.querySelector('[data-thread-name="' + slot + '"]');
        var choices = root.querySelector('[data-thread-choices="' + slot + '"]');

        if (shirtColor) {
          shirtColor.textContent = state.colors[slot] || 'Couleur à choisir';
        }

        if (name) {
          name.textContent = thread ? thread.name : 'À déterminer';
        }

        if (swatch) {
          swatch.style.setProperty(
            '--thread-swatch',
            thread ? thread.hex : 'transparent'
          );
        }

        if (choices) {
          choices.hidden = !showChoices;
        }

        root.querySelectorAll('[data-thread-choice="' + slot + '"]').forEach(function (button) {
          var allowed=allowedThreadOptions(state.colors[slot] || 'Naturel').includes(button.dataset.threadOption);button.hidden=!allowed;button.disabled=!allowed;button.style.display=allowed?'':'none';
          var active = Boolean(
            thread && thread.option === button.dataset.threadOption
          );
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        if (row) {
          row.hidden = state.mode === 'solo' && String(slot) === '2';
        }
      }

      function refreshThreadSummary() {
        var colorGroup = root.querySelector('[data-color-grid="1"]')?.closest('fieldset');
        if(state.mode === 'solo' && threadSummary && colorGroup && threadSummary.parentElement !== colorGroup) colorGroup.appendChild(threadSummary);

        var plan = buildThreadPlan();
        var previousKey = state.threadKey;
        var previousRequired = state.threadConfirmationRequired;
        var key = [
          state.mode,
          plan.type,
          plan.threads[1] ? plan.threads[1].name + ':' + plan.threads[1].hex : '',
          plan.threads[2] ? plan.threads[2].name + ':' + plan.threads[2].hex : ''
        ].join('|');

        if (state.threadKey && state.threadKey !== key && threadConfirmationInput) {
          threadConfirmationInput.checked = false;
        }

        state.threadKey = key;
        state.threads = plan.threads;
        if (threadSummary) threadSummary.hidden = !plan.ready;
        state.threadConfirmationRequired = Boolean(
          plan.ready && plan.confirmationRequired
        );

        if (threadExplanation) {
          threadExplanation.textContent = plan.type === 'inverted'
            ? root.dataset.threadInvertedText
            : root.dataset.threadStandardText;
        }

        var shirtOneLabel = root.querySelector('[data-thread-shirt-label="1"]');
        if (shirtOneLabel) {
          shirtOneLabel.textContent = state.mode === 'solo'
            ? root.dataset.labelTshirtSolo
            : root.dataset.labelTshirtOne;
        }

        renderThreadRow(
          '1',
          plan.threads[1],
          plan.ready && plan.confirmationRequired
        );

        renderThreadRow(
          '2',
          plan.threads[2],
          plan.ready && plan.confirmationRequired && state.mode === 'duo'
        );

        if (threadConfirmation) {
          threadConfirmation.hidden = !state.threadConfirmationRequired;
        }

        if (threadConfirmationInput) {
          threadConfirmationInput.required = state.threadConfirmationRequired;
        }

        var confirmed = Boolean(
          threadConfirmationInput && threadConfirmationInput.checked
        );

        if (threadCompact) {
          if (!plan.ready) {
            threadCompact.textContent = 'Sélectionnez les couleurs des t-shirts.';
          } else if (state.mode === 'solo') {
            threadCompact.textContent = state.colors[1] + ' · fil ' + plan.threads[1].name;
          } else {
            threadCompact.textContent =
              state.colors[1] + ' · fil ' + plan.threads[1].name +
              ' / ' +
              state.colors[2] + ' · fil ' + plan.threads[2].name;
          }
        }

        if (threadStatus) {
          if (!plan.ready) {
            threadStatus.textContent = 'À définir';
          } else if (!plan.confirmationRequired) {
            threadStatus.textContent = 'Automatique';
          } else if (confirmed) {
            threadStatus.textContent = '✓ Validées';
          } else {
            threadStatus.textContent = 'À valider';
          }
        }

        if (threadSummary) {
          if (!plan.ready || plan.type === 'inverted') {
            threadSummary.open = false;
          } else if (
            plan.confirmationRequired &&
            (!previousRequired || previousKey !== key)
          ) {
            threadSummary.open = true;
          }
        }
        if (duoPreview) renderDuoPreview(false);
        if(threadSummary && state.mode !== 'solo') threadSummary.hidden = true;
      }

      function setPressed(elements, active) {
        elements.forEach(function (element) {
          var selected = element === active;
          element.classList.toggle('is-active', selected);
          element.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      }

      function showError(message) {
        if (errorText) {
          errorText.textContent = message;
        } else {
          error.textContent = message;
        }
        error.hidden = false;
        error.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      function clearError() {
        error.hidden = true;
        if (errorText) errorText.textContent = '';
      }

      function showSelectionImage(url, alt) {
        if (!url || !selectionPanel || !selectionImage) return;
        mediaPanels.forEach(function (panel) {
          panel.hidden = true;
          panel.classList.remove('is-active');
        });
        selectionImage.src = url;
        selectionImage.alt = alt || '';
        selectionPanel.hidden = false;
        selectionPanel.classList.add('is-active');
        currentMediaIndex = -1;
        updateGalleryCounter();
      }

      function filterDuoGallery() {
        if (!duoPreview) return;
        allMediaPanels.forEach(function(panel) { panel.hidden = true; panel.classList.remove('is-active'); });
        mediaPanels = allMediaPanels.filter(function(panel) {
          if (state.mode === 'solo') return panel !== duoPreview && !panel.hasAttribute('data-variant-photo') && (!panel.hasAttribute('data-duo-single') || panel.dataset.duoSingle === '1');
          return duoCloseupMode ? panel.hasAttribute('data-duo-single') : !panel.hasAttribute('data-variant-photo') && !panel.hasAttribute('data-duo-single');
        });
        var previewPanel = state.mode === 'duo' ? duoPreview : root.querySelector('[data-duo-single="1"]');
        var previewIndex = mediaPanels.indexOf(previewPanel);
        if (previewIndex >= 0 && !duoCloseupMode) {
          mediaPanels.splice(previewIndex, 1);
          var targetIndex = mediaPanels.length;
          mediaPanels.splice(targetIndex, 0, previewPanel);
        }
      }

      function updateGalleryCounter() {
        if(duoCloseButton) duoCloseButton.hidden = !mediaPanels[currentMediaIndex]?.hasAttribute("data-duo-single");
        if (!galleryCounter) return;
        galleryCounter.textContent = currentMediaIndex < 0
          ? root.dataset.galleryPreviewLabel
          : (currentMediaIndex + 1) + ' / ' + mediaPanels.length;
      }

      function showMediaAtIndex(index) {
        if (!mediaPanels.length) return false;
        var total = mediaPanels.length;
        currentMediaIndex = ((index % total) + total) % total;

        mediaPanels.forEach(function (panel, panelIndex) {
          var active = panelIndex === currentMediaIndex;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });

        if (selectionPanel) {
          selectionPanel.hidden = true;
          selectionPanel.classList.remove('is-active');
        }

        updateGalleryCounter();
        return true;
      }

      function showMediaById(mediaId) {
        if (!mediaId) return false;
        var foundIndex = mediaPanels.findIndex(function (panel) {
          return String(panel.dataset.mediaPanel) === String(mediaId);
        });
        return foundIndex >= 0 ? showMediaAtIndex(foundIndex) : false;
      }

      function showDefaultMedia() {
        if (mediaPanels.length) showMediaAtIndex(0);
      }

      function showVariantMedia(variant) {
        if (!variant) return;
        if (variant.media_id && showMediaById(variant.media_id)) return;
        if (variant.image_url) showSelectionImage(variant.image_url, root.dataset.productTitle);
      }

      function findVariant(color, size) {
        if (colorIndex < 0 || sizeIndex < 0 || !color || !size) return null;
        return variants.find(function (variant) {
          return normalize(variant.options[colorIndex]) === normalize(color) &&
            normalize(variant.options[sizeIndex]) === normalize(size);
        }) || null;
      }

      function findFirstVariantForColor(color) {
        if (colorIndex < 0 || !color) return null;
        var matching = variants.filter(function (variant) {
          return normalize(variant.options[colorIndex]) === normalize(color);
        });
        return matching.find(function (variant) { return variant.available; }) || matching[0] || null;
      }

      function selectedVariant(slot) {
        return findVariant(state.colors[slot], state.sizes[slot]);
      }

      function updateVariantPreview(slot) {
        var variant = selectedVariant(slot) || findFirstVariantForColor(state.colors[slot]);
        if(duoPreview) renderDuoPreview(true);
        else if (variant) showVariantMedia(variant);
        refreshButton();
      }

      function updateDisplayedTotal() {
        var base;
        if (state.mode === 'solo') {
          var variant = selectedVariant(1) || findFirstVariantForColor(state.colors[1]);
          base = variant && Number.isFinite(Number(variant.price)) ? Number(variant.price) : Number(root.dataset.basePrice);
        } else {
          base = Math.round(Number(root.dataset.duoPrice.replace(/[^0-9,.]/g, '').replace(',', '.')) * 100);
        }
        var gift = state.mode === 'solo' && state.giftPack && root.dataset.giftAvailable === 'true' ? Number(root.dataset.giftPrice) : 0;
        if (!Number.isFinite(base) || !Number.isFinite(gift)) return;
        price.textContent = (gift > 0 ? 'Total : ' : '') + new Intl.NumberFormat('fr-FR', {style:'currency', currency:root.dataset.currency}).format((base + gift) / 100);
      }

      function refreshButton() {
        updateDisplayedTotal();
        var defaultLabel = state.mode === 'solo' ? root.dataset.buttonSolo : root.dataset.buttonDuo;
        addLabel.textContent = defaultLabel;
        addButton.disabled = false;

        if (invalidOptions) {
          addButton.disabled = true;
          addLabel.textContent = root.dataset.buttonUnavailable;
          return;
        }

        if (state.mode === 'solo' && state.colors[1] && state.sizes[1]) {
          var soloVariant = selectedVariant(1);
          if (!soloVariant || !soloVariant.available) {
            addButton.disabled = true;
            addLabel.textContent = root.dataset.buttonUnavailable;
          }
        }

        if (state.mode === 'duo' && state.colors[1] && state.sizes[1] && state.colors[2] && state.sizes[2]) {
          var firstVariant = selectedVariant(1);
          var secondVariant = selectedVariant(2);
          if (!firstVariant || !secondVariant || !firstVariant.available || !secondVariant.available) {
            addButton.disabled = true;
            addLabel.textContent = root.dataset.buttonUnavailable;
          }
        }
      }

      function findColorButton(slot, value) {
        return Array.prototype.slice.call(
          root.querySelectorAll('[data-color-choice="' + slot + '"]')
        ).find(function (button) {
          return normalize(button.dataset.value) === normalize(value);
        }) || null;
      }

      function chooseColor(slot, value, button, preservePalette) {
        var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-color-choice="' + slot + '"]'));
        if (normalize(state.colors[slot]) !== normalize(value)) {
          if(!allowedThreadOptions(value).includes(state.threadChoices[slot]))state.threadChoices[slot] = '';
        }
        setPressed(buttons, button);
        state.colors[slot] = value;
        var label = root.querySelector('[data-selected-color-label="' + slot + '"]');
        if (label) label.textContent = '— ' + value;
        if (!preservePalette) {
          setPressed(Array.prototype.slice.call(root.querySelectorAll('[data-palette]')), null);
        }
        clearError();
        refreshThreadSummary();
        updateVariantPreview(slot);
        syncVariantUrl();
      }

      function chooseSize(slot, value, button) {
        var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-size-choice="' + slot + '"]'));
        setPressed(buttons, button);
        state.sizes[slot] = value;
        syncVariantUrl();
        clearError();
        if (state.mode === 'duo' && root.querySelector('[data-palette].is-active')) {
          refreshButton();
        } else {
          refreshButton();
        }
      }

      function setMode(mode) {
        mode = 'solo';
        state.mode = mode;
        filterDuoGallery();
        var solo = mode === 'solo';
        setPressed(
          Array.prototype.slice.call(root.querySelectorAll('[data-mode]')),
          root.querySelector('[data-mode="' + mode + '"]')
        );
        root.classList.toggle('is-solo', solo);
        root.querySelector('[data-solo-motifs]').hidden = true;
        var palettes = root.querySelector('[data-palettes]');
        if (palettes) palettes.hidden = solo;
        root.querySelector('[data-shirt-card="2"]').hidden = solo;
        root.querySelector('[data-size-group="2"]').hidden = solo;
        freeComposer.open = solo;
        if (giftDuo) giftDuo.hidden = solo;
        if (giftSolo) giftSolo.hidden = !solo;
        if (giftSection) giftSection.hidden = solo && !giftSolo;
        if (packagingReassurance) packagingReassurance.hidden = solo;
        price.textContent = solo ? root.dataset.unitePrice : root.dataset.duoPrice;
        addLabel.textContent = solo ? root.dataset.buttonSolo : root.dataset.buttonDuo;

        var title = root.querySelector('[data-shirt-title="1"]');
        var subtitle = root.querySelector('[data-shirt-subtitle="1"]');
        title.textContent = solo
          ? root.dataset.labelTshirtSolo
          : root.dataset.labelTshirtOne;
        subtitle.textContent = solo ? root.dataset.subtitleTshirtSolo : root.dataset.subtitleTshirtOne;
        root.querySelector('[data-composer-title]').textContent = 'Couleur';
        root.querySelector('[data-size-panel-title]').textContent = 'Taille';
        var sizeShirtOneLabel = root.querySelector('[data-size-shirt-label="1"]');
        if (sizeShirtOneLabel) {
          sizeShirtOneLabel.textContent = solo
            ? root.dataset.labelTshirtSolo
            : root.dataset.labelTshirtOne;
        }

        clearError();
        updateSlotOneIcons();
        refreshThreadSummary();
        if (state.colors[1]) {
          updateVariantPreview(1);
        } else {
          showDefaultMedia();
        }
        refreshButton();
      }

      if (galleryPrevious) {
        galleryPrevious.addEventListener('click', function () {
          showMediaAtIndex(currentMediaIndex < 0 ? mediaPanels.length - 1 : currentMediaIndex - 1);
        });
      }

      if (galleryNext) {
        galleryNext.addEventListener('click', function () {
          showMediaAtIndex(currentMediaIndex < 0 ? 0 : currentMediaIndex + 1);
        });
      }

      if (galleryMain && (mediaPanels.length > 1 || Number(root.dataset.hiddenVariantMediaCount || 0) > 0)) {
        var touchStartX = null;
        var touchStartY = 0;

        galleryMain.addEventListener('touchstart', function (event) {
          if (event.touches?.length !== 1) { touchStartX = null; return; }
          if(event.target.closest('[data-duo-controls],button,input,a') || event.touches?.length !== 1) {touchStartX=null;return;}
          var touch = event.changedTouches && event.changedTouches[0];
          if (!touch) return;
          touchStartX = touch.clientX;
          touchStartY = touch.clientY;
        }, { passive: true });

        galleryMain.addEventListener('touchend', function (event) {
          if (touchStartX === null || event.touches?.length) { touchStartX = null; return; }
          var touch = event.changedTouches && event.changedTouches[0];
          if (!touch) return;
          if(touchStartX === null)return;
          var distanceX = touch.clientX - touchStartX;
          var distanceY = touch.clientY - touchStartY;
          touchStartX = null;
          if (Math.abs(distanceX) < 45 || Math.abs(distanceX) <= Math.abs(distanceY)) return;
          showMediaAtIndex(
            distanceX < 0
              ? (currentMediaIndex < 0 ? 0 : currentMediaIndex + 1)
              : (currentMediaIndex < 0 ? mediaPanels.length - 1 : currentMediaIndex - 1)
          );
        }, { passive: true });
      }

      root.querySelectorAll('[data-mode]').forEach(function (button) {
        button.addEventListener('click', function () {
          setMode(button.dataset.mode);
        });
      });

      root.querySelectorAll('[data-motif-value]').forEach(function (button) {
        button.addEventListener('click', function () {
          state.motif = button.dataset.motifValue;
          state.motifIconUrl = button.dataset.motifIconUrl || '';
          setPressed(Array.prototype.slice.call(root.querySelectorAll('[data-motif-value]')), button);
          root.querySelector('[data-shirt-title="1"]').textContent = root.dataset.labelTshirtSolo;
          updateSlotOneIcons();
          clearError();
        });
      });

      root.querySelectorAll('[data-palette]').forEach(function (button) {
        button.addEventListener('click', function () {
          var color1 = button.dataset.colorOne || '';
          var color2 = button.dataset.colorTwo || '';

          chooseColor('1', color1, findColorButton('1', color1), true);
          chooseColor('2', color2, findColorButton('2', color2), true);
          setPressed(Array.prototype.slice.call(root.querySelectorAll('[data-palette]')), button);

          if (button.dataset.imageUrl) {
            showSelectionImage(button.dataset.imageUrl, button.dataset.imageAlt);
          } else {
            showDefaultMedia();
          }
          refreshThreadSummary();
        });
      });

      root.querySelectorAll('[data-thread-choice]').forEach(function (button) {
        button.addEventListener('click', function () {
          if(state.mode !== 'solo') return;
          if(button.hidden || button.disabled)return;
          var slot = button.dataset.threadChoice;
          var option = button.dataset.threadOption;
          if (!allowedThreadOptions(state.colors[slot]).includes(option)) return;

          if (state.threadChoices[slot] !== option) {
            state.threadChoices[slot] = option;
            if (threadConfirmationInput) threadConfirmationInput.checked = false;
          }

          clearError();
          refreshThreadSummary();
          renderDuoPreview(true);
        });
      });

      if (threadConfirmationInput) {
        threadConfirmationInput.addEventListener('change', function () {
          clearError();
          refreshThreadSummary();
        });
      }

      if (giftSoloInput) {
        giftSoloInput.addEventListener('change', function () {
          state.giftPack = Boolean(giftSoloInput.checked);
          updateDisplayedTotal();
          clearError();
        });
      }

      root.querySelectorAll('[data-color-choice]').forEach(function (button) {
        button.addEventListener('click', function () {
          chooseColor(button.dataset.colorChoice, button.dataset.value, button);
        });
      });

      root.querySelectorAll('[data-size-choice]').forEach(function (button) {
        button.addEventListener('click', function () {
          chooseSize(button.dataset.sizeChoice, button.dataset.value, button);
        });
      });

      root.querySelectorAll('[data-more-colors]').forEach(function (button) {
        button.addEventListener('click', function () {
          var slot = button.dataset.moreColors;
          var expanded = button.getAttribute('aria-expanded') === 'true';
          root.querySelectorAll('[data-color-choice="' + slot + '"].is-extra').forEach(function (choice) {
            choice.hidden = expanded;
          });
          button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          button.textContent = expanded ? root.dataset.moreColors : root.dataset.lessColors;
        });
      });

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        clearError();

        if (invalidOptions) {
          showError(root.dataset.errorOptions);
          return;
        }

        var missing = [];
        if (state.mode === 'solo' && !state.motif) missing.push(root.dataset.errorMotif);
        if (!state.colors[1]) missing.push(state.mode === 'solo' ? root.dataset.errorColorSolo : root.dataset.errorColorOne);
        if (!state.sizes[1]) missing.push(state.mode === 'solo' ? root.dataset.errorSizeSolo : root.dataset.errorSizeOne);
        if (state.mode === 'duo') {
          if (!state.colors[2]) missing.push(root.dataset.errorColorTwo);
          if (!state.sizes[2]) missing.push(root.dataset.errorSizeTwo);
        }
        if (missing.length) {
          showError(root.dataset.errorPrefix + ' : ' + missing.join(', ') + '.');
          return;
        }

        refreshThreadSummary();



        var variant1 = selectedVariant(1);
        var variant2 = state.mode === 'duo' ? selectedVariant(2) : null;
        if (!variant1 || !variant1.available || (state.mode === 'duo' && (!variant2 || !variant2.available))) {
          showError(root.dataset.errorUnavailable);
          return;
        }

        var groupId = 'UNICO-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
        var items;

        if (state.mode === 'duo') {
          items = [
            {
              id: Number(variant1.id),
              quantity: 1,
              properties: {
                'Formule': 'Duo',
                'T-shirt du duo': '1',
                'Motif': motif1,
                'Couleur de broderie': state.threads[1] ? state.threads[1].name : '',
                'Packaging': root.dataset.packaging,
                'Pack cadeau': 'Offert - inclus',
                'Photo souvenir': 'Offerte - incluse',
                '_Groupe UNICO': groupId
              }
            },
            {
              id: Number(variant2.id),
              quantity: 1,
              properties: {
                'Formule': 'Duo',
                'T-shirt du duo': '2',
                'Motif': motif2,
                'Couleur de broderie': state.threads[2] ? state.threads[2].name : '',
                'Packaging': root.dataset.packaging,
                'Pack cadeau': 'Offert - inclus',
                'Photo souvenir': 'Offerte - incluse',
                '_Groupe UNICO': groupId
              }
            }
          ];
          if (root.dataset.giftPhotoEnabled !== 'true') {
            delete items[0].properties['Photo souvenir'];
            delete items[1].properties['Photo souvenir'];
          }
        } else {
          items = [
            {
              id: Number(variant1.id),
              quantity: 1,
              properties: {
                'Formule': 'À l’unité',
                'Motif': state.motif,
                'Couleur de broderie': state.threads[1] ? state.threads[1].name : ''
              }
            }
          ];

          items[0].properties['Packaging'] = 'Packaging cadeau inclus';
          items[0].properties[isCaractere ? 'Carte symbole' : 'Carte Astro'] = 'Incluse';

        }

        addButton.disabled = true;
        addLabel.textContent = root.dataset.buttonLoading;

        Promise.resolve(window.unicoSaveCartPreview ? window.unicoSaveCartPreview(root, items) : null).then(function () { return fetch(root.dataset.cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: items })
        }); })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (data) {
                throw new Error(data.description || root.dataset.errorAdd);
              });
            }
            return response.json();
          })
          .then(function () {
            window.location.href = root.dataset.cartUrl;
          })
          .catch(function (failure) {
            addButton.disabled = false;
            addLabel.textContent = state.mode === 'solo' ? root.dataset.buttonSolo : root.dataset.buttonDuo;
            showError(failure.message || root.dataset.errorAdd);
          });
      });

      if (invalidOptions) {
        showError(root.dataset.errorOptions);
      }

      showDefaultMedia();
      if (duoControls) {
        root.addEventListener('click',function(event) {
          var thread = event.target.closest('[data-gallery-thread]');
          if (thread) {
            var source = root.querySelector('[data-thread-choice="'+thread.dataset.galleryThread+'"][data-thread-option="'+thread.dataset.threadOption+'"]');
            if (source) source.click();
            return;
          }

          var more = event.target.closest('[data-duo-more]');
          if(more && more.closest('[data-duo-controls]')) {
            galleryColorsExpanded[more.dataset.duoMore]=!galleryColorsExpanded[more.dataset.duoMore];
            refreshDuoSwatches();
            refreshDuoSingles();
            return;
          }
          var color = event.target.closest('[data-duo-color]');
          if(color && color.closest('[data-duo-controls]')) chooseColor(color.dataset.duoColor,color.dataset.value,findColorButton(color.dataset.duoColor,color.dataset.value));
        });
        duoCloseButton.addEventListener('click', openDuoZoom);
        var lastDuoSwipe = 0, duoTapStart = null;
        galleryMain.addEventListener('touchstart', function(event) {
          duoTapStart = event.touches.length === 1 ? {x:event.touches[0].clientX,y:event.touches[0].clientY} : null;
        }, {passive:true});
        galleryMain.addEventListener('touchend', function(event) {
          if (duoTapStart && (Math.abs(event.changedTouches[0].clientX-duoTapStart.x)>12 || Math.abs(event.changedTouches[0].clientY-duoTapStart.y)>12)) lastDuoSwipe=Date.now();
          duoTapStart=null;
        }, {passive:true});
        galleryMain.addEventListener('click', function(event) {
          if (Date.now()-lastDuoSwipe<500 || event.target.closest('button,input,a,[data-duo-controls]')) return;
          if (event.target.closest('[data-calibrated-shirt]')) openDuoZoom();
        });
      }
      var requestedVariantId = new URL(window.location.href).searchParams.get('variant');
      var requestedVariant = variants.find(function (variant) { return String(variant.id) === requestedVariantId; });
      setMode('solo');
      if (requestedVariant && !invalidOptions) {
        var initialColor = requestedVariant.options[colorIndex];
        var initialSize = requestedVariant.options[sizeIndex];
        chooseColor('1', initialColor, findColorButton('1', initialColor), true);
        var initialSizeButton = Array.prototype.slice.call(root.querySelectorAll('[data-size-choice="1"]')).find(function (button) { return normalize(button.dataset.value) === normalize(initialSize); });
        chooseSize('1', initialSize, initialSizeButton);
        var colorButton = findColorButton('1', initialColor);
        if (colorButton && colorButton.hidden) {
          var more = root.querySelector('[data-more-colors="1"]');
          if (more && more.getAttribute('aria-expanded') !== 'true') more.click();
        }
        renderDuoPreview(true);
      } else {
        // The editorial photo is inspiration until a fabric colour is selected.
        // Never silently preselect a different colour from the pictured garment.
        renderDuoPreview(false);
        showDefaultMedia();
      }
    
  }
  function boot(scope) {
    if (scope.matches && scope.matches('[data-unico-config-kind="signastro"]')) init(scope);
    scope.querySelectorAll('[data-unico-config-kind="signastro"]').forEach(init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { boot(document); });
  else boot(document);
  document.addEventListener("shopify:section:load", function (event) { boot(event.target); });
})();









